function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { Platform, StyleSheet, View, TouchableWithoutFeedback } from 'react-native';
import noop from 'lodash/noop';
import omit from 'lodash/omit';
import { withTheme } from '../Theme';
import EventHandler from '../EventHandler';
import StylePropType from '../StylePropType';
import DefaultTag from './Tag';
import DefaultInput from './Input';
const styles = StyleSheet.create({
  container: {
    paddingRight: 0,
    minHeight: 40,
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  tagContainer: {
    zIndex: 11,
    paddingLeft: 12,
    width: '100%',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  input: {
    paddingLeft: 12
  },
  overlay: {
    position: 'absolute',
    zIndex: 10,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }
});
const forbiddenProps = ['style', 'tagStyle', 'inputStyle', 'Tag', 'Input', 'allowNew', 'buildNew', 'onChange'];

const getEventValidationTime = () => {
  if (Platform.OS === 'web') {
    return 0;
  }

  return 400;
};

class TagInput extends EventHandler {
  constructor(props) {
    super(props);

    _defineProperty(this, "onInputRef", ref => {
      this.input = ref;
    });

    _defineProperty(this, "onInputChangeText", text => this.onMount(() => this.setState({
      text
    })));

    _defineProperty(this, "onInputFocus", () => this.focus());

    _defineProperty(this, "onInputBlur", event => {
      setTimeout(() => {
        if (this.isValidEvent(event)) {
          this.blur();
        }
      }, getEventValidationTime());
    });

    _defineProperty(this, "onInputSelect", (__, item) => {
      this.selectTimestamp = Date.now();
      const {
        onChange
      } = this.props;
      const {
        isSameItem,
        tags
      } = this;
      const duplicate = tags.reduce((r, tag) => r || isSameItem(item, tag), false);

      if (!duplicate) {
        onChange(tags.concat(item));
      }

      this.onMount(() => this.setState({
        text: ''
      }));
    });

    _defineProperty(this, "onInputSubmit", () => {
      const {
        text
      } = this.state;
      const {
        allowNew,
        buildNew,
        onChange
      } = this.props;

      if (text && allowNew) {
        onChange(this.tags.concat(buildNew(text)));
        this.onMount(() => this.setState({
          text: ''
        }));
      }
    });

    _defineProperty(this, "onTagDelete", index => {
      const {
        onChange
      } = this.props;
      onChange(this.tags.filter((tag, i) => i !== index));
    });

    _defineProperty(this, "focus", () => {
      const {
        focused
      } = this.state;

      if (!focused) {
        const {
          onFocus
        } = this.props;
        onFocus();
        this.onMount(() => this.setState({
          focused: true
        }));
      }
    });

    _defineProperty(this, "blur", () => {
      const {
        onBlur
      } = this.props;
      onBlur();
      this.onMount(() => this.setState({
        focused: false
      }));
    });

    _defineProperty(this, "itemFilter", item => {
      const {
        isSameItem,
        tags
      } = this;
      return tags.reduce((r, tag) => r && !isSameItem(item, tag), true);
    });

    _defineProperty(this, "isValidEvent", event => {
      if (Platform.OS === 'web') {
        const {
          relatedTarget
        } = event.nativeEvent;

        if (!relatedTarget) {
          return true;
        }

        const parent = document.querySelector(`[data-class~="${this.id}"]`);

        if (!parent) {
          return true;
        }

        return !parent.contains(relatedTarget);
      }

      return !this.selectTimestamp || Date.now() - this.selectTimestamp > 800;
    });

    _defineProperty(this, "isSameItem", (item1, item2) => {
      const {
        getItemValue
      } = this.props;
      return getItemValue(item1) === getItemValue(item2);
    });

    const {
      text: _text,
      value,
      autoFocus
    } = props;
    this.tags = value || [];
    this.state = {
      text: `${_text}`,
      focused: autoFocus
    };
  }

  render() {
    const {
      value,
      Tag,
      tagStyle,
      tagContainerStyle,
      Input,
      inputStyle,
      style,
      getItemValue,
      themeInputStyle,
      readonly
    } = this.props;
    this.tags = value || [];
    const {
      text,
      focused
    } = this.state;
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.container, themeInputStyle.border, themeInputStyle.background, themeInputStyle.opacity, style]
    }, this.tags.length ? /*#__PURE__*/React.createElement(View, {
      style: [styles.tagContainer, tagContainerStyle]
    }, this.tags.map((tag, index) => /*#__PURE__*/React.createElement(Tag, _extends({}, this.props, {
      onDelete: readonly ? noop : this.onTagDelete,
      key: getItemValue(tag),
      tag: tag,
      index: index,
      style: tagStyle
    }))), !focused ? /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
      onPress: readonly ? noop : this.focus
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.overlay
    })) : null) : null, !this.tags.length && !focused ? /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
      onPress: readonly ? noop : this.focus
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.overlay
    })) : null, focused ? /*#__PURE__*/React.createElement(Input, _extends({}, omit(this.props, forbiddenProps), {
      autoFocus: true,
      closeMenuOnSelect: false,
      value: text,
      style: [styles.input, inputStyle],
      itemFilter: this.itemFilter,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      onRef: this.onInputRef,
      onChangeText: this.onInputChangeText,
      onSelect: this.onInputSelect,
      onSubmitEditing: this.onInputSubmit
    })) : null);
  }

}

_defineProperty(TagInput, "propTypes", {
  themeInputStyle: PropTypes.shape().isRequired,
  allowNew: PropTypes.bool,
  buildNew: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  readonly: PropTypes.bool,
  getItemValue: PropTypes.func,
  style: StylePropType,
  tagStyle: StylePropType,
  tagContainerStyle: StylePropType,
  inputStyle: StylePropType,
  Tag: PropTypes.elementType,
  Input: PropTypes.elementType,
  autoFocus: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  value: PropTypes.any // eslint-disable-line

});

_defineProperty(TagInput, "defaultProps", {
  allowNew: true,
  buildNew: text => text,
  onChange: noop,
  onFocus: noop,
  onBlur: noop,
  readonly: false,
  getItemValue: item => item,
  style: null,
  tagStyle: null,
  tagContainerStyle: null,
  inputStyle: null,
  Tag: DefaultTag,
  Input: DefaultInput,
  autoFocus: false,
  text: '',
  value: undefined
});

export default withTheme('TagInput')(TagInput);